module.exports = __webpack_public_path__ + "img/3.101eeddf.png";